/* eslint-disable @typescript-eslint/no-explicit-any */

import { QueryCache, QueryClient } from 'react-query';
import { t } from 'i18next';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function queryErrorHandler(error: undefined): Promise<void> {
	// TODO: add error handling
	// if (error && error.response in TRANSLATION_KEYS.BACKEND_MESSAGES) {
	// 	toast.error(t(error.message), {
	// 		duration: 5000,
	// 	});
	// } else {
	// 	toast.error(t(COMMON_TRANSLATION_KEYS.DEFAULT_ERROR_MESSAGE), {
	// 		duration: 5000,
	// 	});
	// }

	return error;
}

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			onError: (error: any) => queryErrorHandler(error),

			staleTime: 1000 * 60 * 5,
			cacheTime: 1000 * 60 * 60 * 24,
			refetchInterval: 1000 * 60 * 5,
			refetchOnWindowFocus: false, // Maher changed this to false
			// refetchOnReconnect: true,
		},
		mutations: {
			onError: (error: any) => queryErrorHandler(error),
		},
	},
});

export const queryCache = new QueryCache({
	onError: (error: any) => queryErrorHandler(error),
	// onSuccess: () => toast.error(t(COMMON_TRANSLATION_KEYS.DEFAULT_SUCCESS_MESSAGE)),
});
